import { render, staticRenderFns } from "./MailSettingsView.vue?vue&type=template&id=1dac8817&"
import script from "./MailSettingsView.vue?vue&type=script&lang=js&"
export * from "./MailSettingsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports